<template>
    <div>
        <div
            class="echarts row-center"
            style="justify-content: space-between"
            :class="{showMax:showMax,echartsco:devicetype==3 }"
        >
            <div class="left row-center" >
                <Curve
                        v-if="diagramData&&canvasShow&&!canvasData"
                        :chartsData="diagramData"
                ></Curve>
                <img v-else src="@/assets/img/not_found_data.png" alt=""/>
            </div>
            <div
                    v-show="showMax"
                    class="max-right row-center"
                    style="justify-content: space-between"
                    v-if="diagramData&&canvasShow&&!canvasData"
            >
                <div
                        class="row-max row-center"
                        style="justify-content: space-between"
                        v-for="(item, index) in diagramData.legend.data"
                        :key="index"
                >
                    <div class="max-name row-center">{{ name[index] }}</div>
                    <div
                            class="details column-center"
                            style="justify-content: space-evenly"
                    >
                        <div
                                class="row-center"
                                style="width: 100%; justify-content: flex-start"
                        >
                            <span>最大值</span><span>{{ max(item) }}</span
                        ><span></span>
                        </div>
                        <div
                                class="row-center"
                                style="width: 100%; justify-content: flex-start"
                        >
                            <span>最小值</span><span>{{ min(item) }}</span
                        ><span></span>
                        </div>
                        <div
                                class="row-center"
                                style="width: 100%; justify-content: flex-start"
                        >
                            <span>平均值</span><span>{{ average(item) }} {{diagramData.yAxis.name}}</span
                        ><span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
    </div>
</template>

<script>
    

	import {floatFormat} from "../../../util/MathUtil";
	import Curve from "../../Comparison/components/Curve.vue";

    export default {
        name: "",
        components: {
            Curve
        },
        props:{
            showMax:Boolean,
            diagramData:Object,
            canvasData:Boolean,
            devicetype:Number
        },
        data() {
            return {
                diagramDataCopy:{},
                canvasShow:true,
                name:['A相','B相','C相','总']
            }
        },
        computed:{
			
            min() {
				return (key) => {
					let data = this.diagramData.series.filter((e) => {
						return e.name === key;
					});
					if (data.length === 0) {
						return 0;
					}
					if (data[0].data.length === 0) {
						return "--";
					}
					let minValue = Math.min(...data[0].data);
					let minTimeIndex = data[0].data.findIndex((item) => item == minValue);
					let minTime = this.diagramData.xAxis.data[minTimeIndex];
					return (
						floatFormat(Math.min(...data[0].data), 2) +" "+this.diagramData.yAxis.name+
						` (${this.formateTime(minTime)})`
					);
				};
			},
			average() {
				return (key) => {
					let data = this.diagramData.series.filter((e) => {
						return e.name === key;
					});
					if (data.length === 0) {
						return 0;
					}
					if (data[0].data.length === 0) {
						return "--";
					}
					let sum = 0;
					data[0].data.forEach((e) => (sum += +e));
					return floatFormat(sum / data[0].data.length, 2);
				};
			},
			max() {
				return (key) => {
					let data = this.diagramData.series.filter((e) => {
						return e.name === key;
					});
					if (data.length === 0) {
						return 0;
					}
					if (data[0].data.length === 0) {
						return "--";
					}
					let maxValue = Math.max(...data[0].data);
					let maxTimeIndex = data[0].data.findIndex((item) => item == maxValue);
					let maxTime = this.diagramData.xAxis.data[maxTimeIndex];
					return (
						floatFormat(Math.max(...data[0].data), 2) +" "+this.diagramData.yAxis.name+
						` (${this.formateTime(maxTime)})`
					);
				};
			},
        },
        watch:{
            showMax(){
                this.canvasShow = !this.canvasShow;
                this.$nextTick(() => {
                    this.canvasShow = !this.canvasShow;
                });
            }
        },
        mounted(){
            
        },
        methods: {
            formateTime(string) {
                let array = string.split('')
                array.pop()
                if (array.length < 2) {
                    return '0' + array[0] + ':00'
                } else {
                    return array.join('') + ':00'
                }
            },
        },
    };
</script>

<style lang="less" scoped>  
 .showMax {
        div.left {
            .w(580) !important;
        }
    }

.echarts {
    width: 100%;
    .left {
        width: 100%;
        .h(386);
        // height: 100%;
    }

    .max-right {
        .w(210);
        // height: 380px;
        height: 100%;
        // margin-right: 24rem;

        .row-max {
            width: 100%;
            background-color: rgba(0, 43, 102, 0.02);
            // height: 88px;
            margin-bottom: 10rem;
            // align-items:flex-start ;
            padding: 7rem 0 7rem 0px;
            .details {
                .w(155);
                height: 100%;
                // padding: 12rem 0;

                span {
                    margin-right: 8rem;
                    color: rgba(13, 148, 255, 1);
                    font-size: 14rem;

                    &:first-child {
                        color: #333333;
                    }
                }
            }

            .max-name {
                height: 100%;
                .w(50);
                font-size: 14rem;
                font-weight: bold;
                color: #333333;
            }
        }
    }
}
.echartsco{
    .left{
        .h(480);
        margin-top: 20rem;
    }
}
</style>